<template>
    <b-form-group :label="$t('objectives.collaborationHelp')">
        <b-form-radio-group
            id="dropdown-daily-initiatives-profile-form-change-status"
            :checked="value"
            @change="$emit('change', $event)"
        >
            <b-form-radio value="objective">{{ $t('objectives.objectiveChild') }}</b-form-radio>
            <b-form-radio value="key_result">{{ $t('keyResult.keyResult') }}</b-form-radio>
        </b-form-radio-group>
    </b-form-group>
</template>

<script>
export default {
    props: {
        value: String,
    },
}
</script>
